var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{class:{
      app__circular: _vm.onAppCircular
    },attrs:{"indeterminate":"","size":35,"color":_vm.circularColor,"width":_vm.circularWidth}}),_vm._v(" "),_c('div',{class:{
      'overlay--active': _vm.overlayActive,
      'background-color-default': _vm.onBackgroundColor
    }})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e834718","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_atoms/loadings/LoadingOverlayCircular.vue
// module id = null
// module chunks = 